// SANDFORM catalogue (display) + WhatsApp inquiry helper. Prices mirror the
// backend source of truth; the server re-validates every checkout.

export const WHATSAPP_NUMBER = "971501907317";

export const buildWhatsAppLink = (message) => {
  const base = `https://wa.me/${WHATSAPP_NUMBER}`;
  const msg = message || "Hello SANDFORM! I have a question about your peptides.";
  return `${base}?text=${encodeURIComponent(msg)}`;
};

const vials = {
  weightloss: "/media/vial-weightloss.png",
  recovery: "/media/vial-recovery.png",
  energy: "/media/vial-energy.png",
  neuro: "/media/vial-neuro.png",
  skincare: "/media/vial-skincare.png",
};

export const CATEGORIES = [
  {
    id: "weight-loss", label: "Weight Loss", icon: "Zap", vial: vials.weightloss,
    products: [
      { id: "tirzepatide-15", name: "Tirzepatide 15mg", price: 300, desc: "Dual GIP/GLP-1 agonist for appetite control and accelerated fat loss." },
      { id: "tirzepatide-30", name: "Tirzepatide 30mg", price: 400, desc: "Higher-dose dual agonist for sustained, aggressive body recomposition." },
      { id: "tirzepatide-60", name: "Tirzepatide 60mg", price: 500, desc: "Maximum-dose protocol for advanced weight management goals." },
      { id: "retatrutide-15", name: "Retatrutide 15mg", price: 400, desc: "Next-gen triple agonist targeting fat mass with metabolic precision." },
      { id: "retatrutide-30", name: "Retatrutide 30mg", price: 600, desc: "Elevated triple-receptor dosing for serious transformation phases." },
      { id: "retatrutide-60", name: "Retatrutide 60mg", price: 850, desc: "Top-tier retatrutide protocol for peak metabolic output." },
      { id: "tesamorelin-5", name: "Tesamorelin 5mg", price: 250, desc: "GHRH analog engineered to strip stubborn visceral abdominal fat." },
    ],
  },
  {
    id: "recovery", label: "Recovery", icon: "Wrench", vial: vials.recovery,
    products: [
      { id: "ghk-cu-100", name: "GHK-Cu 100mg", price: 250, desc: "Copper peptide driving tissue repair, collagen and deep recovery." },
      { id: "pt-141-10", name: "PT-141 10mg", price: 250, desc: "Melanocortin peptide supporting libido, arousal and vitality." },
      { id: "klow-80", name: "KLOW 80mg", price: 350, desc: "Synergistic recovery blend for regeneration and skin quality." },
    ],
  },
  {
    id: "energy-muscle", label: "Energy & Muscle", icon: "Flame", vial: vials.energy,
    products: [
      { id: "nad-500", name: "NAD+ 500mg", price: 300, desc: "Cellular energy and longevity coenzyme for mitochondrial output." },
      { id: "mots-c", name: "MOTS-C", price: 250, desc: "Mitochondrial peptide boosting metabolism, endurance and performance." },
      { id: "b12-boost", name: "B12 Boost", price: 200, desc: "High-potency B12 for clean energy, focus and daily drive." },
    ],
  },
  {
    id: "neuro-mind", label: "Neuro & Mind", icon: "BrainCircuit", vial: vials.neuro,
    products: [
      { id: "selank-10", name: "Selank 10mg", price: 250, desc: "Anxiolytic peptide for calm focus, resilience and mental clarity." },
      { id: "semax-10", name: "Semax 10mg", price: 250, desc: "Nootropic peptide enhancing cognition, memory and concentration." },
    ],
  },
  {
    id: "skin-care", label: "Skin Care", icon: "Sparkles", vial: vials.skincare,
    products: [
      { id: "snap-8-10", name: "SNAP-8 10mg", price: 150, desc: "Expression-line smoothing peptide. Includes The Ordinary Hyaluronic Acid." },
    ],
  },
];

export const BUNDLE_ITEMS = [
  "Peptide Vial",
  "Bacteriostatic Water (3ml / 10ml)",
  "16 Alcohol Pads",
  "10 Injection Syringes",
  "1 Mixing Syringe",
];

export const WHY_US = [
  { title: "99.5%+ Purity", desc: "Lab-verified compounds. No fillers, no compromise.", icon: "Percent" },
  { title: "Third-Party Tested", desc: "Independent testing on every single batch.", icon: "FlaskConical" },
  { title: "Cold-Chain Delivery", desc: "Temperature-controlled from vault to door.", icon: "Snowflake" },
  { title: "48H UAE Delivery", desc: "Fast, tracked dispatch across the Emirates.", icon: "Truck" },
  { title: "Discreet Packaging", desc: "Unbranded, sealed and private every time.", icon: "PackageCheck" },
  { title: "Expert WhatsApp Support", desc: "Real protocol guidance, one message away.", icon: "MessageCircle" },
];

export const MANIFESTO = [
  { num: "01", title: "The Standard", body: "Every vial is held to a purity most brands won't publish. If it isn't 99.5%+ and third-party verified, it never reaches you." },
  { num: "02", title: "The Work", body: "Peptides don't replace discipline. They amplify it. This is for people already in the gym, already dialed in, already serious." },
  { num: "03", title: "The Result", body: "No hype cycles. No shortcuts. Just measurable change in your body and your life, delivered discreetly across the UAE." },
];

export const FREE_DELIVERY_THRESHOLD = 1000;
export const DELIVERY_FEE = 30;
